import { render } from "./Sicons.vue?vue&type=template&id=a3c23f92&scoped=true"
import script from "./Sicons.vue?vue&type=script&lang=js"
export * from "./Sicons.vue?vue&type=script&lang=js"

import "./Sicons.vue?vue&type=style&index=0&id=a3c23f92&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-a3c23f92"

export default script